import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    fechaVigenciaDesde: moment(new Date()).format('YYYY-MM-DD'),
    fechaVigenciaHasta: moment(new Date()).format('YYYY-MM-DD'),
    indicadorSemestre: null,
    indicadorSemestreNombre: null,
    indicadorAnio: null,
    indicadorSemestreBase: null,
    indicadorSemestreBaseNombre: null,
    indicadorAnioBase: null,
    descripcion: '',
    rowVersion: null,
    
    clientes: [],
    objetivosMensuales: [],
    
    pjeInflacion: 0,
    montoBase: 0,
    montoBaseAjustado: 0,
    pjeObjetivo: 0,
    montoObjetivo: 0,
    montoBaseSinReembolsos: 0,
    montoBaseAjustadoSinReembolsos: 0,
    pjeObjetivoSinReembolsos: 0,
    montoObjetivoSinReembolsos: 0,

    indicadorDatos: [],
    indicadorValores: [],
    indicadorValoresSinReembolsos: [],
    indicadorClientes: [],
    indicadorObjetivosMensuales: [],

};

const mutations = {
    updateField,

    'INICIALIZAR'(state, indicadorId) {
        state.id = indicadorId || 0;
        state.fechaVigenciaDesde = moment(new Date()).format('YYYY-MM-DD');
        state.fechaVigenciaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.indicadorSemestre = null;
        state.indicadorSemestreNombre = null;
        state.indicadorAnio = null;
        state.indicadorSemestreBase = null;
        state.indicadorSemestreBaseNombre = null;
        state.indicadorAnioBase = null;
        state.descripcion = '';
        state.rowVersion = null;
        
        state.clientes = [];
        state.objetivosMensuales = [];
        
        state.pjeInflacion = 0;
        state.montoBase = 0;
        state.montoBaseAjustado = 0;
        state.pjeObjetivo = 0;
        state.montoObjetivo = 0;
        state.montoBaseSinReembolsos = 0;
        state.montoBaseAjustadoSinReembolsos = 0;
        state.pjeObjetivoSinReembolsos = 0;
        state.montoObjetivoSinReembolsos = 0;
    },
    'SET_INDICADOR'(state, indicador) {
        state.fechaVigenciaDesde = moment(indicador.fechaVigenciaDesde).format('YYYY-MM-DD');
        state.fechaVigenciaHasta = moment(indicador.fechaVigenciaHasta).format('YYYY-MM-DD');
        state.indicadorSemestre = indicador.indicadorSemestre;
        state.indicadorSemestreNombre = indicador.indicadorSemestre == 1 ? '1er Semestre' : '2do Semestre';
        state.indicadorAnio = indicador.indicadorAnio;
        state.indicadorSemestreBase = indicador.indicadorSemestreBase;
        state.indicadorSemestreBaseNombre = indicador.indicadorSemestreBase == 1 ? '1er Semestre' : '2do Semestre';
        state.indicadorAnioBase = indicador.indicadorAnioBase;
        state.descripcion = indicador.descripcion.trim();
        state.rowVersion = indicador.rowVersion;

        state.clientes = indicador.clientes.sort((a, b) => {
            if (a.cliente && b.cliente) {
                return a.cliente.localeCompare(b.cliente);
            }
            return 0;
        });
        
        state.objetivosMensuales = indicador.objetivosMensuales;
        
        if (!indicador.objetivosMensuales || indicador.objetivosMensuales.length == 0) {
            if (indicador.indicadorSemestre == 1) {
                state.objetivosMensuales = [
                    { mes: 1, mesNombre: 'Enero', pjeObjetivo: 0 },
                    { mes: 2, mesNombre: 'Febrero', pjeObjetivo: 0 },
                    { mes: 3, mesNombre: 'Marzo', pjeObjetivo: 0 },
                    { mes: 4, mesNombre: 'Abril', pjeObjetivo: 0 },
                    { mes: 5, mesNombre: 'Mayo', pjeObjetivo: 0 },
                    { mes: 6, mesNombre: 'Junio', pjeObjetivo: 0 }
                ];
            } else {
                state.objetivosMensuales = [
                    { mes: 7, mesNombre: 'Julio', pjeObjetivo: 0 },
                    { mes: 8, mesNombre: 'Agosto', pjeObjetivo: 0 },
                    { mes: 9, mesNombre: 'Septiembre', pjeObjetivo: 0 },
                    { mes: 10, mesNombre: 'Octubre', pjeObjetivo: 0 },
                    { mes: 11, mesNombre: 'Noviembre', pjeObjetivo: 0 },
                    { mes: 12, mesNombre: 'Diciembre', pjeObjetivo: 0 }
                ];
            }
        }

        state.pjeInflacion = parseFloat(indicador.pjeInflacion);
        state.montoBase = parseFloat(indicador.montoBase);
        state.montoBaseAjustado = parseFloat(indicador.montoBaseAjustado);
        state.pjeObjetivo = parseFloat(indicador.pjeObjetivo);
        state.montoObjetivo = parseFloat(indicador.montoObjetivo);
        state.montoBaseSinReembolsos = parseFloat(indicador.montoBaseSinReembolsos);
        state.montoBaseAjustadoSinReembolsos = parseFloat(indicador.montoBaseAjustadoSinReembolsos);
        state.pjeObjetivoSinReembolsos = parseFloat(indicador.pjeObjetivoSinReembolsos);
        state.montoObjetivoSinReembolsos = parseFloat(indicador.montoObjetivoSinReembolsos);
    },
    'INICIALIZAR_OBJETIVOS_MENSUALES' (state) {
        let semestre = 0;
        if (state.indicadorSemestreNombre) {
            if (state.indicadorSemestreNombre.trim() == '1er Semestre') {
                semestre= 1;
            } else if (state.indicadorSemestreNombre.trim() == '2do Semestre') {
                semestre= 2;
            }
        }

        state.objetivosMensuales = [];
        
        if (semestre == 1) {
            state.objetivosMensuales = [
                { mes: 1, mesNombre: 'Enero', pjeObjetivo: 0 },
                { mes: 2, mesNombre: 'Febrero', pjeObjetivo: 0 },
                { mes: 3, mesNombre: 'Marzo', pjeObjetivo: 0 },
                { mes: 4, mesNombre: 'Abril', pjeObjetivo: 0 },
                { mes: 5, mesNombre: 'Mayo', pjeObjetivo: 0 },
                { mes: 6, mesNombre: 'Junio', pjeObjetivo: 0 }
            ];
        } else if (semestre == 2) {
            state.objetivosMensuales = [
                { mes: 7, mesNombre: 'Julio', pjeObjetivo: 0 },
                { mes: 8, mesNombre: 'Agosto', pjeObjetivo: 0 },
                { mes: 9, mesNombre: 'Septiembre', pjeObjetivo: 0 },
                { mes: 10, mesNombre: 'Octubre', pjeObjetivo: 0 },
                { mes: 11, mesNombre: 'Noviembre', pjeObjetivo: 0 },
                { mes: 12, mesNombre: 'Diciembre', pjeObjetivo: 0 }
            ];
        }
    },
    'ADD_CLIENTE'(state, params) {
        let index = state.clientes.findIndex(t => t.clienteId == params.clienteId);
        if (index == -1) {
            state.clientes.push({
                clienteId: params.cliente? params.cliente.id : 0,
                cliente: params.cliente? params.cliente.nombre.trim() : '',
                pjeParticipacion: parseFloat(params.pjeParticipacion)
            });

            state.clientes = state.clientes.sort((a, b) => {
                if (a.cliente && b.cliente) {
                    return a.cliente.localeCompare(b.cliente);
                }
                return 0;
            });
        }
    },
    'REMOVE_CLIENTE'(state, clienteId) {
        let index = state.clientes.findIndex(t => t.clienteId == clienteId);
        if (index != -1) {
            state.clientes.splice(index, 1);
        }
    },
    'INICIALIZAR_OBJETIVO' (state) {
        state.pjeInflacion = 0;
        state.montoBase = 0;
        state.montoBaseAjustado = 0;
        state.montoObjetivo = 0;
        state.montoBaseSinReembolsos = 0;
        state.montoBaseAjustadoSinReembolsos = 0;
        state.montoObjetivoSinReembolsos = 0;
    },
    'SET_OBJETIVO' (state, indicador) {
        state.montoBase = parseFloat(indicador.montoBase);
        state.pjeInflacion = parseFloat(indicador.pjeInflacion);
        state.montoBaseAjustado = parseFloat(indicador.montoBaseAjustado);
        state.montoObjetivo = parseFloat(indicador.montoObjetivo);

        state.montoBaseSinReembolsos = parseFloat(indicador.montoBaseSinReembolsos);
        state.montoBaseAjustadoSinReembolsos = parseFloat(indicador.montoBaseAjustadoSinReembolsos);
        state.montoObjetivoSinReembolsos = parseFloat(indicador.montoObjetivoSinReembolsos);
    },
    'CALCULAR_MONTO_OBJETIVO' (state) {
        state.montoObjetivo = helpers.methods.roundToTwo(parseFloat(state.montoBaseAjustado) * (1 + parseFloat(state.pjeObjetivo) / 100));
    },
    'CALCULAR_PJE_OBJETIVO' (state) {
        state.pjeObjetivo = 0;
        if (state.montoBaseAjustado != 0) {
            state.pjeObjetivo = helpers.methods.roundToTwo((state.montoObjetivo / state.montoBaseAjustado - 1) * 100);
        }
    },
    'CALCULAR_MONTO_OBJETIVO_SIN_REEMBOLSOS' (state) {
        state.montoObjetivoSinReembolsos = helpers.methods.roundToTwo(parseFloat(state.montoBaseAjustadoSinReembolsos) * (1 + parseFloat(state.pjeObjetivoSinReembolsos) / 100));
    },
    'CALCULAR_PJE_OBJETIVO_SIN_REEMBOLSOS' (state) {
        state.pjeObjetivoSinReembolsos = 0;
        if (state.montoBaseAjustadoSinReembolsos != 0) {
            state.pjeObjetivoSinReembolsos = helpers.methods.roundToTwo((state.montoObjetivoSinReembolsos / state.montoBaseAjustadoSinReembolsos - 1) * 100);
        }
    },

    'INICIALIZAR_DATOS' (state) {
        state.indicadorDatos = [];
        state.indicadorValores = [];
        state.indicadorValoresSinReembolsos = [];
        state.indicadorClientes = [];
        state.indicadorObjetivosMensuales = [];
    },
    'SET_DATOS' (state, params) {
        state.indicadorDatos = params.indicadorDatos;
        state.indicadorValores = params.indicadorValores;
        state.indicadorValoresSinReembolsos = params.indicadorValoresSinReembolsos;
        state.indicadorClientes = params.indicadorClientes.sort((a, b) => {
            if (a.cliente && b.cliente) {
                return a.cliente.localeCompare(b.cliente);
            }
            return 0;
        });
        state.indicadorObjetivosMensuales = params.indicadorObjetivosMensuales || [];
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, indicadorId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', indicadorId);

            if (indicadorId != 0) {
                apiAxios.get(`indicadores-ventas/${indicadorId}/abm`) 
                    .then(res => {
                        commit('SET_INDICADOR', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            if (state.indicadorSemestreNombre.trim() == '1er Semestre') {
                state.indicadorSemestre= 1;
            }
            if (state.indicadorSemestreNombre.trim() == '2do Semestre') {
                state.indicadorSemestre= 2;
            }
            if (state.indicadorSemestreBaseNombre.trim() == '1er Semestre') {
                state.indicadorSemestreBase= 1;
            }
            if (state.indicadorSemestreBaseNombre.trim() == '2do Semestre') {
                state.indicadorSemestreBase= 2;
            }
            let objetivosMensuales = [];
            if (state.objetivosMensuales.some(item => parseFloat(item.pjeObjetivo) != 0)) {
                objetivosMensuales = state.objetivosMensuales.map(item => ({
                    mes: item.mes,
                    pjeObjetivo: parseFloat(item.pjeObjetivo),
                }))
            }

            let indicador = {
                fechaVigenciaDesde: moment(state.fechaVigenciaDesde).format('YYYY-MM-DD'),
                fechaVigenciaHasta: moment(state.fechaVigenciaHasta).format('YYYY-MM-DD'),
                indicadorSemestre: parseFloat(state.indicadorSemestre),
                indicadorAnio: parseFloat(state.indicadorAnio),
                indicadorSemestreBase: parseFloat(state.indicadorSemestreBase),
                indicadorAnioBase: parseFloat(state.indicadorAnioBase),
                // pjeObjetivo: parseFloat(state.pjeObjetivo),
                montoObjetivo: parseFloat(state.montoObjetivo),
                montoObjetivoSinReembolsos: parseFloat(state.montoObjetivoSinReembolsos),
                descripcion: state.descripcion.trim(),
                clientes: state.clientes.map(item => ({
                    clienteId: item.clienteId,
                    pjeParticipacion: parseFloat(item.pjeParticipacion)
                })),
                objetivosMensuales
            }

            let url = 'indicadores-ventas';
            if (state.id != 0) {
                url += '/' + state.id;
                indicador.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, indicador)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    addCliente ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('ADD_CLIENTE', params);
            resolve();
        })            
    },
    removeCliente ( { commit }, clienteId ) {
        return new Promise((resolve, reject) => {
            commit('REMOVE_CLIENTE', clienteId);
            resolve();
        })            
    },
    inicializarObjetivo ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_OBJETIVO');
            resolve();
        })
    },
    calcularObjetivo ( { state, commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_OBJETIVO');

            if (state.indicadorSemestreNombre.trim() == '1er Semestre') {
                state.indicadorSemestre= 1;
            }
            if (state.indicadorSemestreNombre.trim() == '2do Semestre') {
                state.indicadorSemestre= 2;
            }
            if (state.indicadorSemestreBaseNombre.trim() == '1er Semestre') {
                state.indicadorSemestreBase= 1;
            }
            if (state.indicadorSemestreBaseNombre.trim() == '2do Semestre') {
                state.indicadorSemestreBase= 2;
            }

            let queryString = '?indicadorSemestre=' + parseInt(state.indicadorSemestre)
                + '&indicadorAnio=' + parseInt(state.indicadorAnio)
                + '&indicadorSemestreBase=' + parseInt(state.indicadorSemestreBase)
                + '&indicadorAnioBase=' + parseInt(state.indicadorAnioBase)
                + '&pjeObjetivo=' + parseFloat(state.pjeObjetivo);

            apiAxios.get('indicadores-ventas/objetivos' + queryString)
                .then(res => {
                    commit('SET_OBJETIVO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    calcularMontoObjetivo ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_MONTO_OBJETIVO');
            resolve();
        })
    },
    calcularPjeObjetivo ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_PJE_OBJETIVO');
            resolve();
        })
    },
    calcularMontoObjetivoSinReembolsos ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_MONTO_OBJETIVO_SIN_REEMBOLSOS');
            resolve();
        })
    },
    calcularPjeObjetivoSinReembolsos ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_PJE_OBJETIVO_SIN_REEMBOLSOS');
            resolve();
        })
    },
    inicializarObjetivosMensuales ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_OBJETIVOS_MENSUALES');
            resolve();
        })
    },

    getDatos ( { commit }, indicadorId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (indicadorId != 0) {
                apiAxios.get('indicadores-ventas/' + indicadorId ) 
                .then(res => {
                    let indicadorDatos = [
                        { 'nombre': 'indicadorAnio', 'campo': 'Año', 'valor': res.data.indicadorAnio, 'formato': '' },
                        { 'nombre': 'indicadorSemestre', 'campo': 'Semestre', 'valor': res.data.indicadorSemestre == 1 ? '1er Semestre' : '2do Semestre', 'formato': '' },
                        { 'nombre': 'indicadorAnioBase', 'campo': 'Año - Base', 'valor': res.data.indicadorAnioBase, 'formato': '' },
                        { 'nombre': 'indicadorSemestreBase', 'campo': 'Semestre - Base', 'valor': res.data.indicadorSemestreBase == 1 ? '1er Semestre' : '2do Semestre', 'formato': '' },
                        // { 'nombre': 'pjeObjetivo', 'campo': 'Pje.Objetivo', 'valor': res.data.pjeObjetivo, 'formato': 'porcentaje' },
                        { 'nombre': 'fechaVigenciaDesde', 'campo': 'Fecha Vigencia - Desde', 'valor': res.data.fechaVigenciaDesde, 'formato': 'fecha' },
                        { 'nombre': 'fechaVigenciaHasta', 'campo': 'Fecha Vigencia - Hasta', 'valor': res.data.fechaVigenciaHasta, 'formato': 'fecha' },
                        { 'nombre': 'descripcion', 'campo': 'Descripcion', 'valor': res.data.descripcion.trim(), 'formato': '' },
                    ];

                    let indicadorValores = [
                        { 'nombre': 'montoBase', 'campo': 'Monto Base', 'valor': res.data.montoBase, 'formato': 'moneda' },
                        { 'nombre': 'pjeInflacion', 'campo': 'Pje.Inflacion', 'valor': res.data.pjeInflacion, 'formato': 'porcentaje' },
                        { 'nombre': 'montoBaseAjustado', 'campo': 'Monto Base Ajustado', 'valor': res.data.montoBaseAjustado, 'formato': 'moneda' },
                        { 'nombre': 'pjeObjetivo', 'campo': 'Pje.Objetivo', 'valor': res.data.pjeObjetivo, 'formato': 'porcentaje' },
                        { 'nombre': 'montoObjetivo', 'campo': 'Monto Objetivo', 'valor': res.data.montoObjetivo, 'formato': 'moneda' },
                    ];

                    let indicadorValoresSinReembolsos = [
                        { 'nombre': 'montoBaseSinReembolsos', 'campo': 'Monto Base', 'valor': res.data.montoBaseSinReembolsos, 'formato': 'moneda' },
                        { 'nombre': 'pjeInflacion', 'campo': 'Pje.Inflacion', 'valor': res.data.pjeInflacion, 'formato': 'porcentaje' },
                        { 'nombre': 'montoBaseAjustadoSinReembolsos', 'campo': 'Monto Base Ajustado', 'valor': res.data.montoBaseAjustadoSinReembolsos, 'formato': 'moneda' },
                        { 'nombre': 'pjeObjetivoSinReembolsos', 'campo': 'Pje.Objetivo', 'valor': res.data.pjeObjetivoSinReembolsos, 'formato': 'porcentaje' },
                        { 'nombre': 'montoObjetivoSinReembolsos', 'campo': 'Monto Objetivo', 'valor': res.data.montoObjetivoSinReembolsos, 'formato': 'moneda' },
                    ];

                    let params = {
                        indicadorDatos,
                        indicadorValores,
                        indicadorValoresSinReembolsos,
                        indicadorClientes: res.data.clientes,
                        indicadorObjetivosMensuales: res.data.objetivosMensuales
                    }

                    commit('SET_DATOS', params);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
            
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}